import { ConfigProvider, App } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import React from 'react';

interface AntdConfigProviderProps {
  children: React.ReactNode;
}

export const COLOR_PRIMARY = 'rgb(51 130 235)';
export const COLOR_PRIMARY_HOVER = 'rgb(7,64,141)';
export const PRIMARY_GRADIENT = 'linear-gradient(90deg, #49CF6D, #3FB044)';

export default function AntdConfigProvider({
  children,
}: AntdConfigProviderProps): React.ReactElement {
  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          fontFamily: 'Helvetica',
          // colorPrimary: COLOR_PRIMARY,
          colorPrimary: '#49CF6D',
          colorLink: '#49CF6D',
          colorLinkHover: COLOR_PRIMARY_HOVER,
          colorLinkActive: COLOR_PRIMARY,
        },
      }}
    >
      <App>
        <div className="antd-gradient-theme">{children}</div>
      </App>
    </ConfigProvider>
  );
}
